// Excel service for Natural Intelligence Test
import * as XLSX from 'xlsx';

// Шаблон Excel файла для тестов
const createExcelTemplate = (testResult) => {
  const { userInfo, allCategories, answers } = testResult;
  
  // Создаем новую рабочую книгу
  const workbook = XLSX.utils.book_new();
  
  // Определяем тип теста и соответствующие данные
  let tableData, sheetName, titleColumn;
  
  if (testResult.testType === 'intelligence_types') {
    // Для типов интеллекта
    tableData = [
      ['Типы интеллекта', 'Пункты анкеты', 'Общая сумма', 'с коэффициентом', 'Общее значение'],
      ['Лингвистический', '5,12,25,26,43,49,56,64,76', allCategories['Лингвистический']?.score || 0, allCategories['Лингвистический']?.coefficient_score || 0, 10],
      ['Математико-логический', '6,14,29,35,38,47,59,67,77', allCategories['Математико-логический']?.score || 0, allCategories['Математико-логический']?.coefficient_score || 0, 10],
      ['Визуально-пространственный', '2,24,31,55,68,71,75,81,88', allCategories['Визуально-пространственный']?.score || 0, allCategories['Визуально-пространственный']?.coefficient_score || 0, 10],
      ['Музыкальный', '4,13,22,34,48,54,69,82,85', allCategories['Музыкальный']?.score || 0, allCategories['Музыкальный']?.coefficient_score || 0, 10],
      ['Межличностный', '3,11,16,30,41,45,61,70,83', allCategories['Межличностный']?.score || 0, allCategories['Межличностный']?.coefficient_score || 0, 10],
      ['Внутриличностный', '10,18,20,33,50,62,74,84,89', allCategories['Внутриличностный']?.score || 0, allCategories['Внутриличностный']?.coefficient_score || 0, 10],
      ['Грубый телесный', '7,19,28,32,36,42,58,79,87', allCategories['Грубый телесный']?.score || 0, allCategories['Грубый телесный']?.coefficient_score || 0, 10],
      ['Прекрасный телесный', '1,9,17,23,37,40,51,63,78', allCategories['Прекрасный телесный']?.score || 0, allCategories['Прекрасный телесный']?.coefficient_score || 0, 10],
      ['Визуально-графический', '15,27,44,53,57,60,66,73,80', allCategories['Визуально-графический']?.score || 0, allCategories['Визуально-графический']?.coefficient_score || 0, 10],
      ['Натуралистический (природный)', '8,21,39,46,52,65,72,86,90', allCategories['Натуралистический (природный)']?.score || 0, allCategories['Натуралистический (природный)']?.coefficient_score || 0, 10]
    ];
    sheetName = 'Типы интеллекта';
    titleColumn = 'Типы интеллекта';
  } else {
    // Для типов натуры (по умолчанию)
    tableData = [
      ['Типы натуры', 'Пункты анкеты', 'Общая сумма', 'с коэффициентом', 'Общее значение'],
      ['Защитный характер', '1,5,10,16,23,34,42,53,68', allCategories['Защитный характер']?.score || 0, allCategories['Защитный характер']?.coefficient_score || 0, 10],
      ['Воспитательный характер', '3,9,13,22,35,48,51,59,71', allCategories['Воспитательный характер']?.score || 0, allCategories['Воспитательный характер']?.coefficient_score || 0, 10],
      ['Административный характер', '7,15,21,26,29,31,36,62,75', allCategories['Административный характер']?.score || 0, allCategories['Административный характер']?.coefficient_score || 0, 10],
      ['Творческая натура', '4,6,14,27,33,37,45,54,70', allCategories['Творческая натура']?.score || 0, allCategories['Творческая натура']?.coefficient_score || 0, 10],
      ['Исцеляющая (целебная) природа', '11,17,30,41,43,46,58,67,74', allCategories['Исцеляющая (целебная) природа']?.score || 0, allCategories['Исцеляющая (целебная) природа']?.coefficient_score || 0, 10],
      ['Развлекательный характер', '12,25,39,44,49,52,55,64,78', allCategories['Развлекательный характер']?.score || 0, allCategories['Развлекательный характер']?.coefficient_score || 0, 10],
      ['Обеспечивающая Природа', '8,20,32,38,50,57,63,72,79', allCategories['Обеспечивающая Природа']?.score || 0, allCategories['Обеспечивающая Природа']?.coefficient_score || 0, 10],
      ['Предпринимательский характер', '2,18,40,47,60,65,73,76,80', allCategories['Предпринимательский характер']?.score || 0, allCategories['Предпринимательский характер']?.coefficient_score || 0, 10],
      ['Авантюрная натура', '19,24,28,56,61,66,69,77,81', allCategories['Авантюрная натура']?.score || 0, allCategories['Авантюрная натура']?.coefficient_score || 0, 10]
    ];
    sheetName = 'Типы натуры';
    titleColumn = 'Типы натуры';
  }
  
  // Создаем лист с результатами
  const worksheet = XLSX.utils.aoa_to_sheet(tableData);
  
  // Добавляем информацию о пользователе в начало
  const userInfoData = [
    ['Информация о тестируемом:'],
    ['Имя:', userInfo.full_name],
    ['Email:', userInfo.email],
    ['Телефон:', userInfo.phone],
    ['Дата прохождения:', new Date().toLocaleDateString('ru-RU')],
    ['Время прохождения:', new Date().toLocaleTimeString('ru-RU')],
    [''],
    ['Результаты теста:']
  ];
  
  // Объединяем данные
  const allData = [...userInfoData, ...tableData];
  const finalWorksheet = XLSX.utils.aoa_to_sheet(allData);
  
  // Добавляем лист в книгу
  XLSX.utils.book_append_sheet(workbook, finalWorksheet, sheetName);
  
  // Создаем лист с детальными ответами
  const answersData = [
    ['Номер вопроса', 'Ответ'],
    ...Object.entries(answers).map(([question, answer]) => [question, answer])
  ];
  
  const answersWorksheet = XLSX.utils.aoa_to_sheet(answersData);
  XLSX.utils.book_append_sheet(workbook, answersWorksheet, 'Детальные ответы');
  
  return workbook;
};

// Экспорт Excel файла
export const exportToExcel = (testResult) => {
  try {
    const workbook = createExcelTemplate(testResult);
    const fileName = `Natural_Intelligence_Test_${testResult.userInfo.full_name.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
    
    // Генерируем и скачиваем файл
    XLSX.writeFile(workbook, fileName);
    
    return {
      success: true,
      fileName: fileName,
      message: 'Excel файл успешно создан и скачан'
    };
  } catch (error) {
    console.error('Ошибка при создании Excel файла:', error);
    return {
      success: false,
      error: error.message,
      message: 'Ошибка при создании Excel файла'
    };
  }
};

// Создание Excel файла в формате Blob для отправки по email
export const createExcelBlob = (testResult) => {
  try {
    const workbook = createExcelTemplate(testResult);
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    return {
      success: true,
      blob: blob,
      fileName: `Natural_Intelligence_Test_${testResult.userInfo.full_name.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`
    };
  } catch (error) {
    console.error('Ошибка при создании Excel Blob:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Форматирование данных для email
export const formatTestDataForEmail = (testResult) => {
  const { userInfo, allCategories, topTypes, dominantType, dominantPercentage } = testResult;
  
  let emailContent = '';
  let testTitle = '';
  
  if (testResult.testType === 'intelligence_types') {
    testTitle = 'АНКЕТА ПО ТИПАМ ИНТЕЛЛЕКТА';
    emailContent = `
📊 РЕЗУЛЬТАТЫ ${testTitle}

👤 ИНФОРМАЦИЯ О ТЕСТИРУЕМОМ:
Имя: ${userInfo.full_name}
Email: ${userInfo.email}
Телефон: ${userInfo.phone}
Дата прохождения: ${new Date().toLocaleDateString('ru-RU')} в ${new Date().toLocaleTimeString('ru-RU')}

🏆 ТОП-3 ТИПА ИНТЕЛЛЕКТА:
`;
    
    if (topTypes && topTypes.length > 0) {
      topTypes.forEach((type, index) => {
        emailContent += `${index + 1}. ${type.type}: ${type.percentage}%\n`;
      });
    }
  } else {
    testTitle = 'ТЕСТА ПО ПРИРОДНЫМ ИНТЕЛЛЕКТАМ';
    emailContent = `
📊 РЕЗУЛЬТАТЫ ${testTitle}

👤 ИНФОРМАЦИЯ О ТЕСТИРУЕМОМ:
Имя: ${userInfo.full_name}
Email: ${userInfo.email}
Телефон: ${userInfo.phone}
Дата прохождения: ${new Date().toLocaleDateString('ru-RU')} в ${new Date().toLocaleTimeString('ru-RU')}

🏆 ДОМИНИРУЮЩИЙ ТИП: ${dominantType} (${dominantPercentage}%)
`;
  }
  
  emailContent += `
📈 ДЕТАЛЬНЫЕ РЕЗУЛЬТАТЫ:
`;
  
  Object.entries(allCategories).forEach(([category, data]) => {
    emailContent += `${category}: ${data.score} баллов (${data.percentage}%)\n`;
  });
  
  emailContent += `
📋 ОТВЕТЫ НА ВОПРОСЫ:
`;
  
  // Добавляем первые 10 ответов для примера
  const sampleAnswers = Object.entries(testResult.answers).slice(0, 10);
  sampleAnswers.forEach(([question, answer]) => {
    emailContent += `Вопрос ${question}: ${answer}\n`;
  });
  
  if (Object.keys(testResult.answers).length > 10) {
    emailContent += `... и еще ${Object.keys(testResult.answers).length - 10} ответов\n`;
  }
  
  return emailContent;
};
